const internalTelServiceName = "/InternalTelInfo";

export function internalTelServices(http) {
    return {        
        getUserInternalTelInfo: (data) => {
            return http.get(internalTelServiceName + "/GetByGeneralId", data)
        }
    }
}
